/**
 * If changing the page paths, remember to change the folder name in the app folder as well.
 */
export const ARTICLES_PAGE_PATH = '/artikler';
export const PROJECTS_PAGE_PATH = '/prosjekter';
export const CLIENTS_PAGE_PATH = '/kunder';
export const PARTNERS_PAGE_PATH = '/partnere';
export const SERVICES_PAGE_PATH = '/tjenester';
export const ABOUT_PAGE_PATH = '/om-oss';

export const SITE_NAME = 'Selvklart';
